import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, of } from 'rxjs';
import { SeatsService } from './seats.service';
import { tick } from '@angular/core/testing';
import { AppSettings } from '../app-settings';
import { PaymentService } from './payment.service';
import { CitylokApiService } from './citylok-api.service';
import {
  AppearanceAnimation,
  ButtonLayoutDisplay,
  ButtonMaker,
  DialogBelonging,
  DialogInitializer,
  DialogLayoutDisplay,
  DisappearanceAnimation,
} from '@costlydeveloper/ngx-awesome-popup';
import { DialogPaymentConfirmComponent } from '../components/dialog-payment-confirm/dialog-payment-confirm.component';
import { TicketsEventService } from './tickets-event.service';
import { DialogErrorBondsComponent } from '../components/dialog-error-bonds/dialog-error-bonds.component';
import { DialogPayComponent } from '../components/dialog-pay/dialog-pay.component';
import { DialogInfoComponent } from '../components/dialog-info/dialog-info.component';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  constructor(
    private ticketsEventService: TicketsEventService,
    private seatsService: SeatsService,
    private paymentService: PaymentService,
    private citylokApiService: CitylokApiService,
    private http: HttpClient,
    @Inject('dialogBelonging') public dialogBelonging: DialogBelonging
  ) { }

  private cartState = new BehaviorSubject<any>({ cartLines: [] });
  cartStateObs$ = this.cartState.asObservable();

  private cartCollapsedState = new BehaviorSubject<boolean>(
    localStorage.getItem('cart_default_collapsed') === 'true'
  );
  cartCollapsed$ = this.cartCollapsedState.asObservable();

  setCartCollapsed(collapsed: boolean) {
    localStorage.setItem('cart_default_collapsed', String(collapsed));
    this.cartCollapsedState.next(collapsed);
  }

  private deleteItems = new BehaviorSubject<any>(null);
  deleteItemsObs$ = this.deleteItems.asObservable();

  private deleteCartItems = new BehaviorSubject<any>(null);
  deleteCartObs$ = this.deleteCartItems.asObservable();

  private payCartItems = new BehaviorSubject<any>(null);
  payCartObs$ = this.payCartItems.asObservable();

  private selectedSeats = new BehaviorSubject<any[]>([]);
  private canvasSeats = new BehaviorSubject<any>([]);
  private bookedSeats = new BehaviorSubject<any>([]);
  private upadateMap = new BehaviorSubject<any>([]);
  public objectUpdateMap = this.upadateMap.asObservable();
  private seatsPayment = [];
  private payComponent = DialogPayComponent;
  clearStorageData() {
    localStorage.setItem('cartState', JSON.stringify({ cartLines: [] }));
    localStorage.setItem('bookedSeats', JSON.stringify([]));
  }

  getCartState() {
    return this.cartState.getValue();
  }

  setCartConfirmed(event: any) {
    this.payCartItems.next(event);
  }

  getPriceCart() {
    const cartLines = this.cartState.getValue().cart_lines;
    let total = 0;
    let fees = 0;
    cartLines.forEach(line => {
      total += +line.price;
      fees += +line.fee;
    });
    return { total: total, fees: fees };
  }

  getSelectedSeats() {
    return this.selectedSeats.getValue();
  }

  updateSelectedSeats(selectedSeats: any) {
    this.selectedSeats.next(selectedSeats);
  }

  getCanvasSeats() {
    return this.canvasSeats.getValue();
  }

  clearBookedSeats() {
    this.bookedSeats.next([]);
    this.cartState.next(null);
    this.seatsPayment = [];
    this.clearStorageData();
  }

  removeCanvasSeat(seatSelected) {
    let index = this.getCanvasSeats().findIndex(
      (value) =>
        value.section.id == seatSelected.section &&
        value.row == seatSelected.row &&
        value.seat == seatSelected.seat
    );
    var selectedSeat = this.getCanvasSeats()[index];
    this.getCanvasSeats().splice(index, 1);
    this.upadateMap.next(selectedSeat);
    return selectedSeat;
  }

  removeSeatsBookedPayment(seatBooked) {
    let index = this.seatsPayment.findIndex(
      (value) =>
        value.position.sectionId == seatBooked.section &&
        value.position.row == seatBooked.row &&
        value.position.seat == seatBooked.seat
    );
    this.seatsPayment.splice(index, 1);
  }

  getCartQuantity() {
    return (this.cartState.getValue().cart_lines || []).reduce((acc: number, l: any) => acc + (l.quantity || 1), 0);
  }

  clearCart() {
    this.clearCartPayment();
    this.emptyCart().subscribe((data) => { });
  }

  getCartLinesByEvent(idEvent: number) {
    return (this.cartState.getValue().cart_lines || [])
      .filter((element: any) => element.event?.id == idEvent)
      .reduce((acc: number, element: any) => acc + (element.quantity || 1), 0);
  }

  clearCartPayment() {
    this.cartState.next(null);
    this.canvasSeats.next([]);
    this.selectedSeats.next([]);
    this.bookedSeats.next([]);
    this.seatsPayment = [];
    this.clearStorageData();
  }

  clearCartState() {
    this.canvasSeats.next([]);
    // Borrar carrito
    this.deleteCart();
    this.clearBookedSeats();
  }

  deleteCart() {
    const idCart = this.cartState.getValue().id;
    return this.http.delete<any>(AppSettings.API_URI_V2 + '/cart/' + idCart).pipe(
      map(data => {
        this.cartState.next(null);
        return data;
      })
    );
  }

  confirmOrder(paymentMethod, payloadForm) {
    return new Promise((resolve, reject) => {
      //TODO: Abonos

      this.ticketsEventService
        .checkCartBonds()
        .subscribe({
          next: (checkBonds) => {
            if (checkBonds.success) {
              const payload = {
                work_time_cash_register_id: localStorage.getItem('id_work_time'),
                payment_method: paymentMethod,
                cash: payloadForm.cash,
                change: payloadForm.change,
              };

              if (paymentMethod === 'tpv') {
                this.paymentService.createOrderTPV(payload).subscribe(
                  (res) => {
                    this.printTicketDialog('tpv', res.data.order.id);
                    this.clearCartPayment();
                    resolve(true);
                  },
                  (error) => {

                    reject(error);
                  }
                );
              } else if (paymentMethod === 'cash') {
                this.paymentService.createOrderTPV(payload).subscribe(
                  (res) => {
                    this.printTicketDialog('cash', res.data.order.id);
                    this.clearCartPayment();
                    resolve(true);
                  },
                  (error) => {
                    reject(error);
                  }
                );
              }
            } else {
              this.errorBondsDialog(checkBonds.errors.bonds);
              reject(false);
            }
          }, error: (err) => {
            this.errorBondsDialog(err.error.errors.bonds);
          }
        });
    });
  }

  errorBondsDialog(bonds: any) {
    const dialogPopup = new DialogInitializer(DialogErrorBondsComponent);
    // Any data can be sent to AnyAngularComponent.
    dialogPopup.setCustomData({ bonds: bonds });

    // Set some configuration.
    dialogPopup.setConfig({
      width: '500px',
      layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
      escapeKeyClose: true,
    });

    // Set some custom buttons as list.
    // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
    dialogPopup.setButtons([
      new ButtonMaker('Aceptar', 'submit', ButtonLayoutDisplay.SUCCESS),
    ]);

    // Simply open the popup and observe which button is clicked and,
    // receive optional payload from AnyAngularComponent.
    dialogPopup.openDialog$().subscribe((resp) => { });
  }

  printTicketDialog(channel: any, id: any) {
    const dialogPopup = new DialogInitializer(DialogPaymentConfirmComponent);
    // Any data can be sent to AnyAngularComponent.
    dialogPopup.setCustomData({ channel: channel, id: id });

    // Set some configuration.
    dialogPopup.setConfig({
      width: '500px',
      layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
      escapeKeyClose: true,
    });

    // Set some custom buttons as list.
    // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
    dialogPopup.setButtons([
      new ButtonMaker('', 'info', ButtonLayoutDisplay.INFO),
      new ButtonMaker('Imprimir', 'submit', ButtonLayoutDisplay.SUCCESS),
      new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
    ]);

    // Simply open the popup and observe which button is clicked and,
    // receive optional payload from AnyAngularComponent.
    dialogPopup.openDialog$().subscribe((resp) => { });
  }

  formatNumber(floatValue = 1, decimals = 2, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + '';
    let arraySplitFloat = stringFloat.split('.');
    let decimalsValue = '0';
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join('.');
    let floatFullValue = parseFloat(FullStringValue) + '';
    let formatFloatFullValue = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimals,
      style: 'currency',
      currency: 'EUR',
    }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }


  // new cart service
  getCart() {
    const work_time_cash_register_id = localStorage.getItem('id_work_time');
    const sortPref = localStorage.getItem('cart_sort_preference');
    let url = `${AppSettings.API_URI_V2}/cash-register/cart?work_time_cash_register_id=${work_time_cash_register_id}`;
    if (sortPref) {
      url += `&sort_cart_lines=${sortPref}`;
    }
    return this.http.get<any>(url).pipe(
      map(res => {
        if (res && typeof res.applied_discounts === 'string') {
          try { res.applied_discounts = JSON.parse(res.applied_discounts); } catch { res.applied_discounts = []; }
        }
        if (res?.applied_discounts?.length) {
        }
        this.cartState.next(res);
        return res;
      })
    );
  }

  getCartBookings(session: any) {
    const cartLines = this.cartState.getValue()?.cart_lines;
    let cartBookings = [];
    cartLines?.forEach(line => {
      if (line.id_session === session) {
        line.bookings.forEach(booking => {
          cartBookings.push(booking.id_seat);
        });
      }
    });
    return cartBookings;
  }

  addToCart(line: any) {
    let payload = {
      work_time_cash_register_id: localStorage.getItem('id_work_time'),
      cart_lines: [
        line
      ],
    }
    return this.http.post<any>(AppSettings.API_URI_V2 + '/cash-register/cart', payload).pipe(
      map(res => {
        return res.data;
      })
    );
  }

  addManyToCart(lines: any[]) {
    const payload = {
      work_time_cash_register_id: localStorage.getItem('id_work_time'),
      cart_lines: lines,
    };
    return this.http.post<any>(AppSettings.API_URI_V2 + '/cash-register/cart', payload).pipe(
      map(res => {
        return res.data;
      })
    );
  }

  deleteItemToCart(idCartLine: number, bookings: any[]) {
    const work_time_cash_register_id = localStorage.getItem('id_work_time');
    const url = `${AppSettings.API_URI_V2}/cash-register/cart/${work_time_cash_register_id}/line/${idCartLine}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        this.deleteItems.next(bookings);
        const currentCart = this.cartState.getValue();
        if (currentCart?.cart_lines) {
          const updatedCart = {
            ...currentCart,
            cart_lines: currentCart.cart_lines.filter((l: any) => l.id !== idCartLine)
          };
          this.cartState.next(updatedCart);
        }
        return data;
      })
    );
  }

  emptyCart() {
    const work_time_cash_register_id = localStorage.getItem('id_work_time');
    const url = `${AppSettings.API_URI_V2}/cash-register/cart/${work_time_cash_register_id}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        this.cartState.next(null);
        this.setDeleteCartEvent(true);
        return data;
      })
    );
  }

  setDeleteCartEvent(event: boolean) {
    this.deleteCartItems.next(event);
  }

  getCartId(): number | null {
    return this.cartState.getValue()?.id || null;
  }

  validatePromoCode(cartId: number, code: string) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code/validate`;
    return this.http.post<any>(url, { code, channel: 2 });
  }

  applyPromoCode(cartId: number, code: string) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code`;
    return this.http.post<any>(url, { code, channel: 2 }).pipe(
      map(res => {
        if (res?.cart) {
          const current = this.cartState.getValue();
          this.cartState.next({ ...current, ...res.cart });
        }
        return res;
      })
    );
  }

  removePromoCode(cartId: number) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code`;
    return this.http.delete<any>(url).pipe(
      map(res => {
        if (res?.cart) {
          const current = this.cartState.getValue();
          this.cartState.next({ ...current, ...res.cart });
        }
        return res;
      })
    );
  }

}
